"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Skeleton_1 = tslib_1.__importDefault(require("@mui/material/Skeleton"));
const AvatarContent_1 = tslib_1.__importDefault(require("./AvatarContent"));
const styles_1 = require("./styles");
function AvatarContainer({ loading, size, ...rest }) {
    const { width, height } = styles_1.CONTAINER_SIZES[size || "large"];
    return loading ? (react_1.default.createElement(Skeleton_1.default, { "data-testid": "core/avatar/loading", animation: "wave", variant: "circular", ...{ height, width }, sx: (theme) => ({
            backgroundColor: theme.palette.primary.contrastText,
            color: theme.palette.text.primary,
        }) })) : (react_1.default.createElement(AvatarContent_1.default, { "data-testid": "core/avatar/content", size: size, ...rest }));
}
exports.default = AvatarContainer;
